<template>
  <v-list flat dense>
    <v-list-item @click="toggleAll">
      <v-list-item-action class="mr-2">
        <v-icon :color="selectedItems.length > 0 ? 'grey' : ''">
          {{
          icon
          }}
        </v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>Select All</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-divider class="mt-1"></v-divider>
    <v-list-item-group v-model="selectedItems" multiple>
      <template>
        <v-list-item disabled>
          <v-list-item-content v-if="selectedItems.length == assetTypes.length">
            <v-list-item-title>All Selected</v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-else-if="selectedItems.length">
            <v-list-item-title>
              {{ selectedItems.length }}/{{ assetTypes.length }}
              selected
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-content v-else>
            <v-list-item-title>Please make a selection</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mb1"></v-divider>
      </template>
      <template v-for="(item, i) in assetTypes">
        <v-list-item
          :key="`item-${i}`"
          :value="item"
          active-class="text--accent-4"
          @click="toggle(item)"
        >
          <template v-slot:default="{ active }">
            <v-list-item-action class="mr-2">
              <v-checkbox :input-value="active" :true-value="item" color="grey"></v-checkbox>
            </v-list-item-action>
            <v-list-item-avatar tile size="8" class="mr-2">
              <v-img
                :alt="item.label"
                v-if="appConfig.excludeLegendItems.includes(item.label)"
                :id="item.id"
              ></v-img>
              <v-img
                :alt="item.label"
                v-if="!appConfig.excludeLegendItems.includes(item.label)"
                :src="item.symbol.url"
              ></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>{{ item.label }}</v-list-item-title>
            </v-list-item-content>
          </template>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { loadModules } from 'esri-loader';

import appConfig from '../config/appConfig';

export default {
  data() {
    return {
      selectedItems: [],
      appConfig: appConfig
    };
  },
  mounted() {
    this.selectedItems = this.assetTypes;
    loadModules(['esri/symbols/support/symbolUtils'], {
      css: true
    }).then(([symbolUtils]) => {
      this.selectedItems.map((item) => {
        symbolUtils.renderPreviewHTML(item.symbol, {
          node: document.getElementById(item.id),
          size: item.symbol.size
        });
      });
    });
  },
  computed: {
    allAssets() {
      return this.selectedItems.length === this.assetTypes.length;
    },
    someAssets() {
      return this.selectedItems.length > 0 && !this.allAssets;
    },
    icon() {
      if (this.allAssets) return 'mdi-close-box';
      if (this.someAssets) return 'mdi-minus-box';
      return 'mdi-checkbox-blank-outline';
    },
    ...mapGetters({
      assetTypes: 'filterData/assetTypes'
    })
  },
  methods: {
    ...mapActions({
      setFilterItem: 'filterData/setFilterItem'
    }),
    toggle(event) {
      const currentItems = this.selectedItems.filter(
        (item) => item.value !== event.value
      );
      if (!this.selectedItems.find((i) => i.value === event.value)) {
        currentItems.push(event);
      }
      this.setFilterItem({
        filterType: 'energy',
        filterValue: currentItems.map((item) => {
          return item.value;
        })
      });
    },
    toggleAll() {
      if (this.allAssets) {
        this.selectedItems = [];
        this.setFilterItem({
          filterType: 'energy',
          filterValue: []
        });
        this.setFilterItem({
          filterType: 'energy',
          filterValue: []
        });
      } else {
        this.selectedItems = this.assetTypes;
        this.setFilterItem({
          filterType: 'energy',
          filterValue: this.assetTypes.map((item) => {
            return item.value;
          })
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
